import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDisclosure } from 'src/hooks/useDisclosure';
import CreateReportModal from './CreateReportModal';

type CreateReportButtonProps = {
  onSuccess?: () => void;
};

const CreateReportButton = ({ onSuccess }: CreateReportButtonProps) => {
  const [opened, { open, close }] = useDisclosure();
  const navigate = useNavigate();

  const handleOpen = () => {
    navigate('/');
    open();
  };

  return (
    <>
      <Button onClick={handleOpen}>
        <Typography>สร้างแบบรายงาน Corporate Value Up</Typography>
      </Button>
      <CreateReportModal open={opened} onClose={close} onSuccess={onSuccess} />
    </>
  );
};

export default CreateReportButton;
